module.exports = __webpack_public_path__ + "static/media/np-logo-small.c4986cc7.png";